
import { bl_fi_emp_missing_report_hdr_RowClass } from '../../../dbschema/bl_fi_emp_missing_report_hdr.model';
import { BaseContainerModel } from '../../base-container.model';


export class EmpMissingReportHdrContainer extends BaseContainerModel {
    bl_fi_emp_missing_report_hdr: bl_fi_emp_missing_report_hdr_RowClass = new bl_fi_emp_missing_report_hdr_RowClass();
}
